import { Routes, Route } from "react-router-dom";
import Containers from "./Containers";

const index = () => {
	return (
		<Routes>
			<Route index element={<Containers />} />
		</Routes>
	);
};

export default index;
